import { homePageStyles } from "@insite/content-library/Pages/HomePage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

homePageStyles.page = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    .card-layout-item {
                        flex-basis: 78%;
                    }
                `,
                css`
                    .card-layout-item {
                        flex-basis: 38%;
                    }
                `,
                css`
                    .card-layout-item {
                        flex-basis: 38%;
                    }
                `,
                css`
                    .card-layout-item {
                        flex-basis: 38%;
                    }
                `,
                css`
                    .card-layout-item {
                        flex-basis: 23%;
                    }
                `,
            ])}
        .wrapper {
            margin-top: 40px;
            margin-bottom: 40px;
        }
        .card-layout {
            display: flex;
            flex-wrap: wrap;
            margin-left: -0.25rem;
            margin-right: -0.25rem;
            justify-content: center;
            gap: 15px;
        }
        .card-layout-item {
            padding: 24px 15px;
            background: #f7f7f7;
        }
        .ops-header {
            font-size: 24px;
            text-align: center;
            margin: 0 0 20px;
        }

        .ops-btn a {
            background: #ed1c24;
            padding: 15px 45px;
            text-align: center;
            width: 100%;
            display: block;
            & span {
                color: #fff;
            }
        }
        .ops-btn a:hover {
            color: #fff;
            text-decoration: underline;
            & span {
                color: #fff;
            }
        }
    `,
};
